
import EvaluatorApprovalNotFoundSvgComponent from '../../assets/svg-components/not-found/evaluator-approval';
import './index.scss';

export default function EvaluatorApprovalNotfound() {
  return (
    <>
      <div className="new-not-found-wrap">
        <div className="new-not-found-wrap__details">
          {/* <img
            src="/images/page-not-found/evaluator-approval.svg"
            className="not-found-image img-fluid not-found-image-evaluator-approval"
          /> */}
          <div className='not-found-image img-fluid not-found-image-evaluator-approval'>
            <EvaluatorApprovalNotFoundSvgComponent />
          </div>
          <p className="no-data-found-text">No approval pending for selected timeframe or filters. Please change date or filter criteria to view information.</p>
        </div>
      </div>
    </>
  );
}
